import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import NotificationComponent from '../components/NotificationComponent';
import { fetchAsDataUrl, getOwnProfileImage } from '../utils/imageApi';
import { getCachedBranches, getSelectedBranchId, setCachedBranches, setSelectedBranchId } from '../utils/branch';
import { isAdminOrManager } from '../utils/enums';
import { getAppMode, setAppMode } from '../utils/appMode';
import { endSession } from '../utils/session';

var config = process.env;

class NavbarComponent extends Component {

	constructor(){
        super();
        this.state = {
            src: "./images/empty-user.png",
            branches: [],
            selectedBranchId: getSelectedBranchId() || '',
            cafeteriaEnabled: false,
        }
    }

    componentDidMount = () => {
        this.loadProfileImage()
        this.loadBranches()
        this.loadCafeteriaFlag()
    }

    loadCafeteriaFlag = () => {
        if (!isAdminOrManager(this.props.role)) {
            return;
        }
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'cafeteria/config', {
            headers: { 'access-token': localStorage.getItem('token') },
        })
        .then((r) => r.json())
        .then((data) => {
            if (data.error === 0 && data.data) {
                this.setState({ cafeteriaEnabled: !!data.data.enabled });
            }
        })
        .catch(() => {});
    }

    changeMode = (mode) => {
        setAppMode(mode);
        // Navega a una pantalla del modo elegido + recarga (sidebar + navbar releen el modo).
        window.location.href = mode === 'cafeteria' ? '/cafeteria' : '/purchase';
    }

    resolveSelectedBranchId = (branches, currentSelected = getSelectedBranchId()) => {
        const allowAllBranches = branches.length > 1;
        const isAllSelected = currentSelected === 'all' && allowAllBranches;
        const branchExists = branches.some(branch => String(branch.id) === String(currentSelected));

        return branchExists
            ? String(currentSelected)
            : isAllSelected
                ? 'all'
                : branches.length > 0
                    ? String(branches[0].id)
                    : '';
    }

    loadBranches = () => {
        const cachedBranches = getCachedBranches();
        if (cachedBranches != null) {
            const selectedBranchId = this.resolveSelectedBranchId(cachedBranches);
            if (selectedBranchId) {
                setSelectedBranchId(selectedBranchId);
            }

            this.setState({
                branches: cachedBranches,
                selectedBranchId,
            });

            return;
        }

        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'branch/mine', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error === 0 && Array.isArray(data.data)) {
                const branches = data.data;
                const selectedBranchId = this.resolveSelectedBranchId(branches);

                if (selectedBranchId) {
                    setSelectedBranchId(selectedBranchId);
                }

                setCachedBranches(branches);

                this.setState({
                    branches,
                    selectedBranchId,
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    onChangeBranch = (event) => {
        this.applyBranchSelection(event.target.value);
    }

    applyBranchSelection = (selectedBranchId) => {
        const normalizedBranchId = selectedBranchId == null ? '' : String(selectedBranchId);
        if (normalizedBranchId === this.state.selectedBranchId) {
            return;
        }

        setSelectedBranchId(normalizedBranchId);
        this.setState({ selectedBranchId: normalizedBranchId }, () => {
            window.location.reload();
        });
    }

    getSelectedBranchLabel = () => {
        const { branches, selectedBranchId } = this.state;

        if (selectedBranchId === 'all' && branches.length > 1) {
            return 'Todas';
        }

        const selectedBranch = branches.find(branch => String(branch.id) === String(selectedBranchId));
        return selectedBranch ? selectedBranch.name : 'Sucursal';
    }

    // El navbar está en las 61 pantallas: antes listaba el prefijo `/profile` ENTERO y filtraba en
    // el cliente por nombre de archivo, o sea que se bajaba la lista de emails de todos los admins
    // en cada carga. Ahora el backend devuelve sólo la foto del admin de la sesión (o null).
    loadProfileImage = () => {
        var image = localStorage.getItem('image');
        if (image == undefined || image == '') {
            getOwnProfileImage()
            .then(profileImage => {
                if (profileImage == null) {
                    return;
                }
                // Se cachea el data URL en localStorage para no volver a bajarla en cada pantalla.
                return fetchAsDataUrl(profileImage.contentPath).then(dataUrl => {
                    localStorage.setItem('image', dataUrl);
                    this.setState({ src: profileImage.url });
                });
            })
            .catch(error => {
                // Lectura: si falla se queda el avatar vacío, no se rompe la pantalla.
                console.log(error);
            });
        } else {
            this.setState({ src: image });
        }
    }

    onClickLogout = (event) => {
        event.preventDefault(); // Evitar la acción predeterminada del evento de clic
        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        // Revocar el token en el servidor es un side-effect SECUNDARIO: si falla, igual hay
        // que sacar al usuario. Antes la limpieza y el redirect vivían en el `else` de esta
        // respuesta, así que con la sesión ya vencida el backend contestaba 1002, caía en el
        // alert "La sesión expiró" y el botón no hacía NADA — la única salida de la app
        // fallaba exactamente cuando era la única salida.
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'session/logout', request)
        .catch(() => {})
        .then(() => { endSession(); });
    }

	render() {
        const selectedBranchLabel = this.getSelectedBranchLabel();
        const branchTriggerStyle = {
            paddingLeft: '1rem',
            paddingRight: '1rem',
        };
        const getBranchOptionStyle = (isActive) => ({
            background: isActive ? '#f4f7fb' : '#ffffff',
            color: isActive ? '#3d5170' : '#212529',
            fontWeight: isActive ? 600 : 400,
        });
        const userTriggerStyle = {
            paddingLeft: '1rem',
            paddingRight: '1rem',
        };

        return (  
            <div className="main-navbar sticky-top bg-white">
                <nav className="navbar align-items-stretch navbar-light flex-md-nowrap p-0">
                    <form action="#" className="main-navbar__search w-100 d-none d-md-flex d-lg-flex"></form>
                    {isAdminOrManager(this.props.role) && this.state.cafeteriaEnabled ? (
                        <ul className="navbar-nav border-left flex-row">
                            <li className="nav-item d-flex align-items-center px-3">
                                <span className="text-muted mr-2" style={{ fontSize: '0.85rem' }}>Modo:</span>
                                <select
                                    value={getAppMode()}
                                    onChange={(e) => this.changeMode(e.target.value)}
                                    style={{ fontSize: '0.85rem', border: '1px solid #e1e5eb', borderRadius: '0.25rem', padding: '0.2rem 0.4rem', color: '#3d5170', fontWeight: 600, cursor: 'pointer' }}
                                >
                                    <option value="retail">Retail</option>
                                    <option value="cafeteria">Cafetería</option>
                                </select>
                            </li>
                        </ul>
                    ) : null}
                    {this.state.branches.length > 0 ? (
                        <ul className="navbar-nav border-left flex-row">
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link text-nowrap px-3 h-100 d-flex align-items-center"
                                    data-toggle="dropdown"
                                    href="#"
                                    role="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    style={branchTriggerStyle}
                                >
                                    <span className="text-muted mr-2" style={{ fontSize: '0.85rem' }}>Sucursal:</span>
                                    <span
                                        className="d-inline-block"
                                        style={{ fontSize: '0.85rem', color: '#3d5170', fontWeight: 700 }}
                                    >
                                        {selectedBranchLabel}
                                    </span>
                                    <i className="material-icons ml-1" style={{ fontSize: '18px', color: '#818ea3' }}>expand_more</i>
                                </a>
                                <div className="dropdown-menu dropdown-menu-small">
                                    {this.state.branches.length > 1 ? (
                                        <button
                                            type="button"
                                            className={`dropdown-item${this.state.selectedBranchId === 'all' ? ' active' : ''}`}
                                            style={getBranchOptionStyle(this.state.selectedBranchId === 'all')}
                                            onClick={() => this.applyBranchSelection('all')}
                                        >
                                            Todas
                                        </button>
                                    ) : null}
                                    {this.state.branches.map(branch => (
                                        <button
                                            key={branch.id}
                                            type="button"
                                            className={`dropdown-item${String(branch.id) === String(this.state.selectedBranchId) ? ' active' : ''}`}
                                            style={getBranchOptionStyle(String(branch.id) === String(this.state.selectedBranchId))}
                                            onClick={() => this.applyBranchSelection(branch.id)}
                                        >
                                            {branch.name}
                                        </button>
                                    ))}
                                </div>
                            </li>
                        </ul>
                    ) : null}
                    <ul className="navbar-nav border-left flex-row ">
                        {/* <NotificationComponent /> */}
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link text-nowrap h-100 d-flex align-items-center"
                                data-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style={userTriggerStyle}
                            >
                                <img className="user-avatar rounded-circle mr-2" src={this.state.src} alt="User Avatar" />
                                <span
                                    className="d-none d-md-inline-block"
                                    style={{ color: '#818ea3', fontSize: '0.85rem', fontWeight: 400 }}
                                >
                                    {localStorage.getItem('firstName')} {localStorage.getItem('lastName')}
                                </span>
                                <i className="material-icons ml-1" style={{ fontSize: '18px', color: '#818ea3' }}>expand_more</i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-small">
                                {this.props.role != 4 ? <Link className="dropdown-item" to="/profile"><i className="material-icons">&#xE7FD;</i> Perfil</Link> : ""}
                                {this.props.role != 4 ?<div className="dropdown-divider"></div>: ""}
                                {this.props.role == 1 ? <Link className="dropdown-item" to="/configurations"><i className="material-icons">settings</i> Configuraciones</Link> : ""}
                                {this.props.role == 1 ?<div className="dropdown-divider"></div>: ""}
                                <a className="dropdown-item text-danger" href="" onClick={(event) => this.onClickLogout(event)}>
                                    <i className="material-icons text-danger">&#xE879;</i>Cerrar sesión
                                </a>
                            </div>
                        </li>
                    </ul>
                    <nav className="nav">
                        <a href="#" className="nav-link nav-link-icon toggle-sidebar d-md-inline d-lg-none text-center border-left" data-toggle="collapse" data-target=".header-navbar" aria-expanded="false" aria-controls="header-navbar">
                            <i className="material-icons">&#xE5D2;</i>
                        </a>
                    </nav>
                </nav>
            </div>
        );
    }
    
}

export default NavbarComponent;
